var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sale-print-buttons-common',{attrs:{"sale":_vm.sale,"model_name":"sale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }